export const pl = {
  header: { title: "Działaj globalnie. 2 $ za Short. Dowolny język!", subtitle: "🔥Płać tylko za rezultat – od $0.089 do $0.009 za sekundę🔥" },
  steps: { uploadVideo: "Prześlij Wideo", selectLanguages: "Wybierz Języki", conversionResult: "Konwersja i Wynik" },
  upload: { dragAndDrop: "Przeciągnij i upuść plik wideo tutaj", orClickToSelect: "lub kliknij, aby wybrać", supportedFormats: "Obsługiwane formaty: MP4, AVI, MOV, MKV, WebM", maxFileSize: "• Maksymalny rozmiar pliku: 200 MB", maxDuration: "• Maksymalny czas trwania: 30 sek", processingTime: "• Przetwarzanie zajmie od 2 do 15 minut w zależności od rozdzielczości wideo", chooseFile: "Wybierz Plik", selectedFile: "Wybrany plik:", size: "Rozmiar:", fileTypeError: "Proszę wybrać plik wideo", fileSizeError: "Rozmiar pliku ({size} MB) przekracza maksymalny limit 200 MB", durationError: "Długość wideo ({duration} sek.) przekracza maksymalny limit 30 sek.", fileReadError: "Nie można odczytać pliku wideo. Spróbuj innego pliku." },
  languages: { sourceAudioLanguage: "Język audio źródłowego", targetAudioLanguage: "Język audio docelowego", selectLanguage: "Wybierz język..." },
  languageOptions: { ru: "Rosyjski", en: "Angielski", es: "Hiszpański", fr: "Francuski", de: "Niemiecki", it: "Włoski", pt: "Portugalski", pl: "Polski", zh: "Chiński", ja: "Japoński", ko: "Koreański", bg: "Bułgarski", hr: "Chorwacki", cs: "Czeski", da: "Duński", nl: "Holenderski", et: "Estoński", fi: "Fiński", el: "Grecki", hu: "Węgierski", ga: "Irlandzki", lv: "Łotewski", lt: "Litewski", mt: "Maltański", ro: "Rumuński", sk: "Słowacki", sl: "Słoweński", sv: "Szwedzki" },
  conversion: { replaceAudio: "Sklonuj mój głos", uploadVideoAndSelectLanguages: "Prześlij wideo i wybierz języki, aby kontynuować", fixValidationError: "Proszę naprawić błąd walidacji pliku powyżej", createSubtitles: "Utwórz Napisy", uploadVideoForSubtitles: "Prześlij wideo, aby utworzyć napisy", selectTranslationLanguage: "Wybierz język tłumaczenia" },
  demo: { seeVeviInAction: "Zobacz VEVI w Akcji", watchHowItWorks: "Zobacz jak działa nasza technologia zamiany głosu AI", beforeEnglish: "Przed (Angielski)", originalPresentation: "Oryginalna prezentacja korporacyjna", afterSpanish: "Po (Hiszpański,Francuski,Chiński,Włoski)", aiTranslatedVoice: "Przetłumaczone przez AI z naturalnym głosem", demoTitle: "Demo - VEVI w Akcji" },
  reviews: { title: "Co Mówią Nasi Klienci", subtitle: "Zaufane przez profesjonalistów marketingu na całym świecie", customerReviews: [{ name: "Sarah Johnson", position: "Menedżer Marketingu Cyfrowego", company: "TechFlow Solutions", text: "VEVI przekształciło nasze międzynarodowe kampanie marketingowe!" }, { name: "Michael Chen", position: "Dyrektor Marketingu Treści", company: "GlobalReach Media", text: "Jako ktoś, kto zarządza treściami wideo dla wielu regionów, VEVI to przełom." }, { name: "Emma Rodriguez", position: "Specjalista ds. Marketingu Marki", company: "InnovateCorp", text: "Zaoszczędziliśmy tysiące na kosztach lektorskich ekspandując na nowe rynki." }, { name: "David Thompson", position: "Menedżer Kampanii Marketingowych", company: "NextGen Brands", text: "Prędkość i jakość VEVI są bezkonkurencyjne." }, { name: "Lisa Park", position: "Lider Marketingu Mediów Społecznościowych", company: "CreativeEdge Agency", text: "VEVI umożliwiło naszej małej agencji oferowanie wielojęzycznych usług wideo klientom." }, { name: "James Wilson", position: "Dyrektor Marketingu Wyników", company: "ScaleUp Ventures", text: "ROI to wszystko w marketingu wyników, a VEVI dostarcza." }] },
  payment: { title: "Płatność za Konwersję", processingCost: "Koszt Przetwarzania", duration: "Czas trwania:", baseCost: "Koszt podstawowy", discount: "Zniżka ({promoCode}):", discountAmount: "Kwota zniżki:", total: "Razem:", emailToReceiveResult: "Email do otrzymania wyniku", emailPlaceholder: "twoj-email@przyklad.pl", promoCode: "🎟️ Kod Promocyjny (opcjonalny)", promoCodePlaceholder: "Wprowadź kod promocyjny", check: "Sprawdź", checking: "Sprawdzanie...", addSubtitles: "Dodaj napisy do wideo", addSubtitlesDescription: "Wygeneruj i osadź napisy w języku docelowym", highQualityTranslation: "• Wysokiej jakości tłumaczenie AI", originalVideoPreserved: "• Oryginalne wideo zachowane", fastProcessing: "• Szybkie przetwarzanie (typowo 5-10 minut)", resultWillBeSent: "• Wynik zostanie wysłany na podany email", cancel: "Anuluj", continue: "Kontynuuj", enterEmail: "Proszę wprowadzić swój email", enterValidEmail: "Proszę wprowadzić prawidłowy adres email", enterPromoCode: "Proszę wprowadzić kod promocyjny", invalidPromoCode: "Nieprawidłowy kod promocyjny", validPromoCode: "Prawidłowy kod promocyjny! Zastosowano zniżkę {discount}%" },
  progress: { title: "Przetwarzanie Wideo", uploadingAndExtracting: "🎬 Przesyłanie i wyodrębnianie audio", transcribingAndTranslating: "🗣️ Transkrypcja mowy i tłumaczenie", synthesizingAudio: "🎵 Synteza nowej ścieżki audio", step: "Krok:", error: "Błąd" },
  result: { title: "Gotowe! Twoje wideo zostało przetworzone", conversionCompleted: "Konwersja zakończona pomyślnie!", processedVideoDescription: "🎬 Twoje przetworzone wideo z klonowaniem głosu", payAndDownload: "Zapłać i Pobierz", videoNotAvailable: "Wideo niedostępne", useDownloadButton: "Użyj przycisku pobierania poniżej", downloadError: "Błąd Pobierania" },
  emailSent: { title: "Wideo Wysłane! 🎉", videoOnWay: "Wideo jest już w drodze na twój email 🙏❤️", checkInbox: "Sprawdź swoją skrzynkę odbiorczą i folder spam. Przetworzone wideo przyjedzie wkrótce!", whatsNext: "Co dalej?", checkEmail: "• Sprawdź swój email ({email})", checkSpam: "• Poszukaj w folderze spam jeśli nie znajdziesz", downloadAndEnjoy: "• Pobierz i ciesz się swoim dubbingowanym wideo!", close: "Zamknij", processAnotherVideo: "Przetwórz Inne Wideo" },
  processingSteps: { uploading: "Przesyłanie wideo...", extracting: "Wyodrębnianie audio...", transcribing: "Transkrypcja mowy...", translating: "Tłumaczenie treści...", synthesizing: "Synteza nowego głosu...", rendering: "Renderowanie finalnego wideo...", complete: "Przetwarzanie zakończone!" },
  common: { minutes: "minut", seconds: "sekund", loading: "Ładowanie...", error: "Błąd", success: "Sukces" },
  socialMedia: {
    title: "Zostańmy w Kontakcie",
    description: "Otrzymuj najnowsze aktualizacje na temat technologii głosu AI"
  },

  // Services (for Footer)
  services: {
    dubbing: "Dubbing",
    voiceClone: "Dubbing z klonowaniem głosu",
    newVoice: "Dubbing z nowym głosem",
    multilingual: "Dubbing wielojęzyczny",
    multiSpeaker: "Dubbing wielogłosowy",
    subtitles: "Napisy",
    subtitlesOnly: "Tylko napisy",
    multilingualSubtitles: "Napisy wielojęzyczne",
    subtitlesDescription: "Automatycznie generuj dokładne napisy dla dowolnej platformy.",
    subtitlesPrice: "Koszt przetwarzania: $0.01/sek",
    addSubtitles: "Dodaj napisy",
    needsTranslation: "Potrzebujesz tłumaczenia?",
    translationLanguage: "Język tłumaczenia"
  },

  // Footer
  footer: {
    legal: "Informacje prawne",
    privacyPolicy: "Polityka prywatności",
    termsOfUse: "Warunki użytkowania"
  },

  // Navigation
  nav: {
    blog: "Blog"
  },

  // Blog (using English content as fallback)
  blog: {
    title: "Blog VEVI Monster",
    subtitle: "Historia i mitologia wszechświata VEVI",
    readMore: "Czytaj więcej",
    backToBlog: "Powrót do bloga",
    articleNotFound: "Artykuł nie znaleziony",
    characteristics: "Charakterystyka",
    articles: {
      "vevi-monster": {
        title: "VEVI Monster",
        excerpt: "Vevi to istota narodzona z wirów plazmy Zera-13b. Nie jest ani ciałem, ani metalem—jego ciało składa się z wibrujących cząstek utrzymywanych razem przez pole elektromagnetyczne.",
        metadata: {
          "Galaktyka": "MoM-z14",
          "Wiek": "13,4 miliarda lat",
          "Typ": "Skalista planeta z gęstą atmosferą metanu i neonu",
          "Gwiazda": "Czerwona protogwiazda Zera-13",
          "Orbita": "Druga planeta układu",
        },
        content: [
          "🌑 Opis",
          "Zera-13b to starożytny i prawie zapomniany świat, narodzony w erze, gdy Wszechświat dopiero uczył się świecić.",
          "Jego niebo migocze matowymi zielonymi płomieniami, a gęsta atmosfera drży od burz neonowych. Powierzchnia to czarno-szary krajobraz pokryty szklanymi kraterami, gdzie wiatry metanowe pozostawiają ogniste ślady w powietrzu.",
          "Pod powierzchnią leżą jaskinie zamarzniętego gazu, gdzie według legend narodziły się pierwsze formy energii zdolne do myślenia.",
          "👾 Vevi (Vevi Monster)",
          "Vevi to istota narodzona z wirów plazmy Zera-13b.",
          "Nie jest ani ciałem, ani metalem—jego ciało składa się z wibrujących cząstek utrzymywanych razem przez pole elektromagnetyczne.",
          "Jego oczy świecą odbitym światłem gwiazdy Zera-13, a jego głos brzmi jak szept neonowego wiatru.",
          "Vevi opuścił swój świat, gdy protogwiazda zaczęła gasnąć. Podróżował przez międzygalaktyczne pustki, prowadzony instynktem poszukiwania nowej energii.",
          "Teraz wędruje po światach, niosąc ze sobą cząstkę pierwotnego światła Zera-13b.",
          "Blask otrzymał od planety",
          "Nie ma nóg—ponieważ planeta ma ogromną grawitację i po prostu lewituje",
          "Komunikuje się (lub raczej wydaje dźwięki) podobne do fal akustycznych delfinów, wielorybów i orek.",
          "Jego język nazywa się UFOnic",
        ],
      },
      "baddy-sub": {
        title: "Baddy Sub",
        excerpt: "Baddy Sub to istota z wczesnego Wszechświata, narodzona w Sub Zone, rzadkim regionie kosmosu o wysokiej gęstości materii.",
        metadata: {
          "Nazwa obiektu": "Sub Zone (SUB-Z)",
          "Typ obiektu": "Protoklaster / region formowania galaktyk",
          "Epoka": "~200–300 milionów lat po Wielkim Wybuchu",
          "Przesunięcie ku czerwieni": "z ≈ 14–15",
          "Rektascensja (RA)": "02h 17m 43s",
          "Deklinacja (Dec)": "−04° 12′ 09″",
        },
        content: [
          "Dane Baddy Sub",
          "Długie, cienkie, podłużne ciało z dwiema dolnymi kończynami na dole i trzema oczami na wydłużonych formach na górze",
          "Nie ma ust.",
          "Są też dwie górne cienkie kończyny, które można interpretować jako ręce.",
          "Dwa palce na każdej kończynie.",
          "Całe ciało przypomina gałąź drzewa",
          "Skóra ma gładką matową strukturę",
          "Kolor jest zielonkawo-brązowy (pigmentacja)",
          "Może zmieniać kolor w zależności od otoczenia jak kameleon.",
          "Opis planety, na której urodził się Baddy Sub:",
          "Sub Zone to rzadki region wczesnego Wszechświata o wysokiej gęstości materii, gdzie zaczęły formować się pierwsze struktury galaktyczne. Obserwacje wskazują na intensywne oddziaływania pierwotnego gazu, promieniowania i fal grawitacyjnych. W regionie zarejestrowano niestabilne wzorce sygnałów i anormalną aktywność rezonansową, nietypową dla typowych regionów protogalaktycznych.",
          "Znaczenie naukowe:",
          "Sub Zone jest uważany za kluczowy obiekt do badania wczesnych etapów montażu galaktyk, propagacji sygnałów w młodym Wszechświecie i przejścia od chaotycznych pól promieniowania do ustrukturyzowanych systemów kosmicznych.",
          "Status:",
          "Sklasyfikowany jako nierozwiązany region formowania. Wymagane są dalsze badania.",
        ],
      },
    },
  },

  // FAQ
  faq: {
    title: "Najczęściej Zadawane Pytania",
    subtitle: "Wszystko, co musisz wiedzieć o VEVI",
    questions: [
      {
        question: "Czy pracujecie tylko z głosem?",
        answer: "Tak — zastępujemy twój głos, aby brzmiał w innym języku, zachowując naturalność i autentyczność."
      },
      {
        question: "Płacę przed czy po?",
        answer: "Po. Najpierw słuchasz wyniku, potem płacisz."
      },
      {
        question: "Zwroty pieniędzy?",
        answer: "Nie są potrzebne — płacisz tylko wtedy, gdy jesteś zadowolony z wyniku."
      },
      {
        question: "Wideo dłuższe niż 15 minut?",
        answer: "Żaden problem. Zapytaj naszego asystenta AI na czacie online o instrukcje."
      },
      {
        question: "Czy mogę wybrać inny głos?",
        answer: "Nie — klonujemy tylko twój własny głos."
      },
      {
        question: "Minimalna płatność?",
        answer: "Od $0.50."
      },
      {
        question: "Jak otrzymam moje wideo?",
        answer: "Natychmiastowe pobieranie w przeglądarce + kopia na twój email po płatności."
      },
      {
        question: "Zniżki dla dużych zamówień?",
        answer: "Tak — skontaktuj się z naszym asystentem AI na czacie online."
      },
      {
        question: "Nie znalazłeś swojej odpowiedzi?",
        answer: "Zapytaj naszego asystenta AI na czacie online — jesteśmy tutaj, aby pomóc."
      },
      {
        question: "Nieobsługiwany format?",
        answer: "Użyj konwertera lub uzyskaj szybką pomoc od naszego asystenta AI na czacie online."
      },
      {
        question: "Moje wideo zawiera specyficzne terminy, które muszą być prawidłowo wymawiane. Czy mogę to kontrolować?",
        answer: "Tak — po prostu napisz wiadomość do naszego asystenta AI na czacie online, a wyślemy Ci instrukcje, jak oznaczyć lub zachować określone terminy (na przykład zostawić je po angielsku)."
      },
      {
        question: "Nie otrzymałem mojego emaila. Co powinienem zrobić?",
        answer: "Czas przetwarzania może się różnić ze względu na wielkość kolejki. Nie martw się — Twój plik jest bezpieczny. Otrzymasz powiadomienie lub bezpośredni link do pobrania, gdy będzie gotowy."
      }
    ]
  }
};
